export const partnerLegalInfoTranslation = {
  content: {
    validation: {
      attachments: 'partnerinfo-content-validation-attachments',
    },
    blockTitles: {
      legalCommonBlock: 'partnerinfo-content-blocktitles-legal_common_block',
      legalAddressBlock: 'partnerinfo-content-blocktitles-legal_address_block',
    },
    notification: {
      companyLegalName: 'partnerinfo-content-notification-company_legal_name',
    },
  },
}
